import { FC } from 'react'

import { Flex, Tag } from 'antd'


const TagsMeta: FC<Partial<Pick<MotoGP.RiderStats, 'all_races'>>> = ({ all_races = { categories: [], total: 0 } }) => {
  console.log(all_races)

  const tags = all_races?.categories?.map((it) => ({
    name: it.category.name.replace('™', ''),
    ratio: Math.round((it.count / all_races?.total) * 100),
  }))
  return tags && tags?.length > 0 ? (
    <Flex style={{ width: '100%' }}>
      {tags
        ?.slice()
        .sort((a, b) => b.ratio - a.ratio)
        .map((it) => (
          <Tag bordered key={it.name} color={'volcano-inverse'}>
            {it.name}
          </Tag>
        ))}
    </Flex>
  ) : (
    <div style={{ minHeight: 24 }} />
  )
}

export { TagsMeta }
